module.exports = __webpack_public_path__ + "img/10.70369d21.jpg";